import PropTypes from 'prop-types'

import { ReactComponent as Star1 } from './stars/1.svg'
import { ReactComponent as Star2 } from './stars/2.svg'
import { ReactComponent as Star3 } from './stars/3.svg'
import { ReactComponent as Star4 } from './stars/4.svg'
import { ReactComponent as Star5 } from './stars/5.svg'

const RatingStars = ({ rating }) => {
  const stars = {
    1: Star1,
    2: Star2,
    3: Star3,
    4: Star4,
    4.5: Star4,
    5: Star5
  }

  if (!rating) {
    return null
  }

  const Star = stars[rating]
  return <Star />
}

RatingStars.propTypes = {
  rating: PropTypes.number.isRequired
}

export default RatingStars
